<template>
   <div class="Component-Typeahead">
    <div class="input-group">
        <input v-model="query"
            type="text"
            class="SearchInput input-group-field"
            :placeholder="placeholder |  translate"
            @blur="resetField">
        <div class="input-group-button">
            <button type="button" v-show="query" @click="resetField" class="clear">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

    </div>
    <transition-group name="fade" tag="ul" class="Results">
        <li v-for="item in filtered" :key="item.locIdentity"
            @click="setLocation(item)">
                <span>{{ item.Name }}</span><br><small>{{ labels.locations[item.Typ]| translate }}</small>
        </li>
    </transition-group>
    <ul class="Results" v-if="isEmpty">
        <li v-translate>location-not-found</li>
    </ul>
    </div>
</template>

<script>
import lunr from 'lunr'

export default {
  name: 'Typeahead',

  props: {
    source: {
      type: [String, Array],
      required: true
    },
    startAt: {
      type: Number,
      default: 3
    },
    placeholder: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      items: [],
      idx: null,
      query: '',
      locked: false,
      location: null,
      labels: {
          locations: {
            RG: 'region',
            TO: 'location'
          }
      }
    }
  },

  methods: {
    fetchItems() {
      if (typeof this.source === 'string') {
          fetch(this.source)
            .then(stream => stream.json())
            .then(data => this.items = data)
            .catch(error => console.error(error))
      } else {
          this.items = this.source
      }
    },

    resetField(evt) {
        if (this.locked) return
        this.query = ''
        this.$emit('clearLocation', evt)
    },

    setLocation(item) {
        this.locked = true
        this.query = item.Name
        this.$emit('locSelected', item)

    }
  },

  computed: {
    filtered() {
        if(this.query.length >= this.startAt && !this.locked) {
            let refs = this.idx.search(this.query + '*').map(r => r.ref)
            return this.items.filter(i => { return refs.includes(i.locIdentity)} )
        }
        this.locked = false
    },

    isEmpty() {
        if( typeof this.filtered === 'undefined' ) {
            return false
        } else {
            return this.filtered.length < 1
        }
    }
  },

  watch: {
      /**
       * Rebuild search index whenever items change
       */
      items: function(newItems, oldItems) {

          this.idx = lunr(function () {
              this.ref('locIdentity')
              this.field('Name')

              newItems.forEach(function (doc) {
                  this.add(doc)
              }, this)
          })

      },
      location: function(newVal, oldval) {
        if (typeof newVal !== "string") {
            if (newVal === null) {
                this.locked = true
                this.query = ''
                this.$emit('clearLocation');
            }
            return
        }

        var filtered = this.items.filter( i => (i.locIdentity === newVal))
        if (filtered.length > 0 ) {
            this.locked = true
            this.query = filtered[0].Name
            this.$emit('locSelected', filtered[0])
        }
      }
  },

  mounted () {
      this.fetchItems()
  }
}
</script>

<style type="scss" scoped>

.Component-Typeahead ul.Results li>span {
    font-weight: 600;
}
    .input-group-button button {
        background: #f00;
        font-weight: 700;
        color: white;
        padding: .2rem;
    }
    .Results {
        padding: 0;
        text-align: left;
        margin: -.5rem 1rem 0;
        position: absolute;
        z-index: 99;
        box-shadow: 4px 4px 12px 0px rgba(0,0,0,0.75);
    }
    .Results li {
        background: #0073b6;
        color: white;
        margin: 0;
        padding: .2rem 1rem;
        font-size: 1rem;
        line-height: 1.2;
        list-style: none;
        width: 100%;
        border-bottom: 1px solid white;
        transition: ease-in-out 0.18s;
        cursor: pointer;

        span { font-weight: 500; }
    }
    .Results li>small { font-size: .8rem; line-height: 1; }
    .Results li:hover {
        background: lighten(#0073b6, 20%);
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.18s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Typeahead.vue